import { parseCookie } from './parseCookie';
import { pureRequest } from './request';
import { getCookie } from '@/utils/cookie';
import { ssoSessionStorage } from '@/utils/storage';
import SSOConfig from './SSOConfig';

const getUserInfo = async () => {
  try {
    const res = await pureRequest(SSOConfig.SSOUserInfoUrl, 'GET', {}, null, null);
    if (res.id) return res.id;
  } catch (e) {
    console.log(e);
  }
  const uid = parseCookie(document.cookie)['ssoweb-certification-userid'];
  return uid;
};

export { getUserInfo };

let lxsdkCuid = '';

export function getLxCuid() {
  if (lxsdkCuid) return lxsdkCuid;
  const lxcuid = getCookie('_lxsdk_cuid') || getCookie('_lxsdk') || ssoSessionStorage.getItem('_lxsdk_cuid');
  lxsdkCuid = lxcuid || '';
  return lxcuid;
}
